<script setup>
  import { defineProps, defineEmits } from 'vue';
  import { Dialog as KDialog, DialogButton as KDialogButton } from 'konsta/vue';

  const props = defineProps({
    dialogOpen: Boolean,
  });

  const emit = defineEmits(['response']);

  function handleResponse(response) {
    emit('response', response);
  }
</script>

<template>
  <k-dialog
    :opened="dialogOpen"
    @backdropclick="() => handleResponse(false)"
  >
    <template #title>Conferma Annullamento</template>
    Sei sicuro di voler procedere?
    <template #buttons>
      <k-dialog-button @click="() => handleResponse(false)">No</k-dialog-button>
      <k-dialog-button strong @click="() => handleResponse(true)">Sì</k-dialog-button>
    </template>
  </k-dialog>
</template>

<style lang="scss" scoped>

</style>